import { render } from "./ConfigsModal.vue?vue&type=template&id=00011c20&scoped=true"
import script from "./ConfigsModal.vue?vue&type=script&lang=js"
export * from "./ConfigsModal.vue?vue&type=script&lang=js"

import "./ConfigsModal.vue?vue&type=style&index=0&id=00011c20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00011c20"]])

export default __exports__